<app-table [data]="audits"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [isMaterial]="false"
           [hasTitle]="hasTitle"
           [title]="('admin.audits.table.title' | translate) + (entity ? (' - ' + entity.name) : '')"
           [headerBackgroundColor]="headerBackgroundColor"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)">
    <app-table-column header="{{'admin.audits.table.columns.id' | translate}}"
                      field="id">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-input
                type="number"
                mask="0*"
                [(ngModel)]="column.filterValue"
                placeholder="{{'admin.audits.table.filters.id' | translate}}"
                (inputChange)="table.onFilterChange(column)"></app-input>
        </ng-template>
    </app-table-column>

    <app-table-column header="{{'admin.audits.table.columns.operation' | translate}}"
                      field="operation">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="operations"
                          valueField="name"
                          displayField="name"
                          emptyText="{{'admin.audits.table.filters.operation.placeholder' | translate}}"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
    </app-table-column>

    <app-table-column header="{{'admin.audits.table.columns.propertyName' | translate}}"
                      filterPlaceholder="{{'admin.audits.table.filters.propertyName' | translate}}"
                      [filter]="true"
                      field="propertyName">
    </app-table-column>

    <app-table-column header="{{'admin.audits.table.columns.oldValue' | translate}}"
                      field="oldValue">
    </app-table-column>

    <app-table-column header="{{'admin.audits.table.columns.newValue' | translate}}"
                      field="newValue">
    </app-table-column>

    <app-table-column header="{{'admin.audits.table.columns.modifiedBy' | translate}}"
                      filterPlaceholder="{{'admin.audits.table.filters.modifiedBy' | translate}}"
                      [filter]="true"
                      field="modifiedBy">
    </app-table-column>

    <app-table-column header="{{'admin.audits.table.columns.modifiedAt' | translate}}"
                      field="modifiedAt">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-input-datepicker [(ngModel)]="column.filterValue"
                                  [placeholder]="'admin.audits.table.filters.modifiedAt' | translate"
                                  appendTo="body"
                                  (dateChange)="table.onFilterChange(column)">
            </app-input-datepicker>
        </ng-template>
    </app-table-column>

</app-table>
